/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import Axios from 'axios';
import moment from 'moment';
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  useHistory,
} from 'react-router-dom';
import SubTabComponent from '../components/SubTab';
import AppLayout from '../components/layouts';
import * as SERVICE from '../constants/service.types';
import * as SYSTEM from '../constants/system.keys';
import { useInActiveLogout } from '../hooks/useInActiveLogout';
import HoasenLogo from '../assets/favicon/hoasen_logo.png';
import {
  authLogoutThunk,
  changeLocales,
  getPublicIpReturn,
  socketEmitEvent,
  updateNamespace,
} from '../redux/actions';
import { resetDataToken } from '../redux/socket';
import AppRoutes from '../routes';
import Login from './auth/Login';
import storageService from '../services/storage.service';
import CryptoJS from 'crypto-js';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Spinner from '../components/Spinner';
import { beeXLogger } from '../helpers/logger';

const OPEN_PAGES = 'OPEN_PAGES';
const PAGE_AVAILABLE = 'PAGE_AVAILABLE';
const HOST_NAME = window.location.hostname;
const TITLE_APP = {
  'cloudcam1.hoasengroup.vn': 'Hoa Sen Group',
  'cloudcam.dashhome.vn': 'DashHome',
  'cloudcam.hoasenhome.vn': 'Hoa Sen Home',
};
const ICON_APP = {
  'cloudcam1.hoasengroup.vn': HoasenLogo,
  'cloudcam.hoasenhome.vn': HoasenLogo,
};

const AppInner = ({
  isLogin,
  current,
  mainTabKey,
  allowMultiTab,
  onMainTabChange,
}) => {
  const history = useHistory();
  const { isAuth, namespace } = useSelector((state) => state);

  useEffect(() => {
    if (!isAuth || isAuth !== 1 || !namespace) return;
    const navEntry = performance.getEntriesByType('navigation')[0];
    if (navEntry?.type === 'reload') {
      beeXLogger.debug('Page reloaded');
      const url = new URL(navEntry.name);
      const pathname = url.pathname;
      history.replace(pathname);
    } else {
      beeXLogger.debug('Page loaded');
    }
  }, [isAuth, namespace]);

  return current === mainTabKey || allowMultiTab ? (
    !isLogin ? (
      <>
        <Route exact path="/login">
          <Login />
        </Route>
        <Redirect
          to={{ pathname: `/login`, state: { query: location.search } }}
        />
      </>
    ) : (
      <AppLayout>{AppRoutes}</AppLayout>
    )
  ) : (
    <SubTabComponent onMainTabChange={onMainTabChange} />
  );
};

export default function App() {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const {
    isAuth,
    socketState,
    language,
    namespace,
    dataUser,
    listNamespaceAccount,
  } = useSelector((state) => state);
  const [isLogin, setIsLogin] = useState(false);
  const [isBlockDevTool, setIsBlockDevTool] = useState(false);
  const [isOpenPage, setIsOpenPage] = useState(false);
  const [current] = useState(Date.now());
  const [mainTabKey, setMainTabKey] = useState(Date.now());
  const authSessionLogout = localStorage.getItem(SYSTEM.AUTO_LOGOUT_SESSION);
  const allowMultiTab = +localStorage.getItem(SYSTEM.ALLOW_MULTI_TABS);
  const [isInitialSetup, setIsInitialSetup] = useState(false);
  const [listNamespace, setListNamespace] = useState([]);

  useEffect(() => {
    let result = [];
    const forceChangeNamespace = localStorage.getItem('force_change_namespace');
    const persistedNamespace = localStorage.getItem(SYSTEM.NAMESPACE);
    if (namespace) {
      if (Array.isArray(namespace)) {
        result.push(...namespace);
      } else {
        result.push(namespace);
      }
    }
    if (listNamespaceAccount) {
      let namespacesData = [];
      try {
        const rawNamespaces =
          typeof listNamespaceAccount?.data === 'string'
            ? JSON.parse(listNamespaceAccount.data || '[]')
            : listNamespaceAccount?.data || [];
        namespacesData = (rawNamespaces || [])
          .map((item) => item?.namespace)
          .filter(Boolean);
      } catch (error) {
        namespacesData = [];
      }
      result.push(...namespacesData);
    }
    if (persistedNamespace) result.push(persistedNamespace);
    if (forceChangeNamespace) result.push(forceChangeNamespace);
    setListNamespace([...new Set(result)]);
  }, [namespace, listNamespaceAccount]);

  const initialSetup = useCallback(async () => {
    localStorage.removeItem('auth_token');
    const fp = await FingerprintJS.load();
    const { visitorId } = await fp.get();
    const encryptedToken = localStorage.getItem(SYSTEM.TOKEN) || '';
    try {
      storageService.setInternalStorage({
        fingerPrintKey: visitorId,
        decodedAccessToken: encryptedToken
          ? CryptoJS.AES.decrypt(encryptedToken, visitorId).toString(
              CryptoJS.enc.Utf8,
            )
          : '',
      });
      setIsInitialSetup(true);
    } catch (error) {
      storageService.setInternalStorage({ fingerPrintKey: visitorId });
      setIsInitialSetup(true);
    }
  }, []);

  useLayoutEffect(() => {
    initialSetup();
  }, [initialSetup]);
  useInActiveLogout();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (
        isBlockDevTool &&
        (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I'))
      ) {
        e.preventDefault();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isBlockDevTool]);

  useEffect(() => {
    setIsBlockDevTool(!!dataUser?.enableWatermark);
  }, [dataUser]);

  useEffect(() => {
    const handleRightClick = (e) => {
      if (isBlockDevTool) e.preventDefault();
    };
    window.addEventListener('contextmenu', handleRightClick);
    return () => window.removeEventListener('contextmenu', handleRightClick);
  }, [isBlockDevTool]);

  useEffect(() => {
    if (!isOpenPage) {
      setIsOpenPage(true);
      if (typeof window !== 'undefined') {
        setMainTabKey(current);
        localStorage.setItem(OPEN_PAGES, current);
      }
      window.addEventListener('storage', (e) => {
        if (e.key === OPEN_PAGES) {
          setMainTabKey(parseInt(e.newValue));
          localStorage.setItem(PAGE_AVAILABLE, current);
        }
      });
    }
  }, [current, isOpenPage]);

  const onMainTabChange = useCallback(() => {
    setMainTabKey(current);
    localStorage.setItem(OPEN_PAGES, current);
  }, [current]);

  useEffect(() => {
    const beforeUnloadHandler = (event) => {
      event.preventDefault();
      event.returnValue = '';
      resetDataToken();
      dispatch(authLogoutThunk());
    };
    if (authSessionLogout === 1) {
      window.addEventListener('beforeunload', beforeUnloadHandler);
    }
    return () =>
      window.removeEventListener('beforeunload', beforeUnloadHandler);
  }, [authSessionLogout, dispatch]);

  useEffect(() => {
    async function getPublicIp(cb) {
      try {
        let result = await Axios.get(SYSTEM.CHECK_IP_URL);
        if (result.status === 200) return cb(result.data);
        return cb(null);
      } catch (error) {
        return false;
      }
    }
    getPublicIp((publicIp) => dispatch(getPublicIpReturn(publicIp)));
  }, [dispatch]);

  useEffect(() => {
    let localLanguage = localStorage.getItem(SYSTEM.LANGUAGE);
    if (!localLanguage || localLanguage.length === 0) localLanguage = 'en';
    dispatch(changeLocales(localLanguage));
  }, [dispatch]);

  useEffect(() => {
    if (isInitialSetup) {
      const token = storageService.getInternalStorageByKey(
        SYSTEM.DECODED_ACCESS_TOKEN,
      );
      if (token) {
        if (socketState === 1 && language) {
          let dataBody = {
            language,
            accessToken: token,
            appId: SYSTEM.APP_ID,
            encrypted: 1,
            agent: `${window.navigator.userAgent}_web`,
          };
          dispatch(
            socketEmitEvent({
              appServiceType: SERVICE.AUTHENTICATION,
              requestId: new Date().getTime(),
              body: JSON.stringify(dataBody),
            }),
          );
        }
      } else {
        resetDataToken();
        dispatch(authLogoutThunk());
      }
    }
  }, [dispatch, language, socketState, isInitialSetup]);

  useEffect(() => {
    if (isAuth === -1) {
      setIsLogin(false);
      return;
    }
    if (isAuth !== 1) return;

    const namespaceStorage = localStorage.getItem(SYSTEM.NAMESPACE);
    const forceChangeNamespace = localStorage.getItem('force_change_namespace');
    const preferredNamespace = forceChangeNamespace || namespaceStorage;

    if ((!listNamespace || listNamespace.length === 0) && preferredNamespace) {
      dispatch(updateNamespace(preferredNamespace));
      return;
    }

    if (listNamespace && listNamespace.length > 0) {
      const activeNamespace =
        preferredNamespace && listNamespace.includes(preferredNamespace)
          ? preferredNamespace
          : listNamespace[0];

      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.REGISTER_NOTIFICATION,
          requestId: new Date().getTime(),
          body: JSON.stringify({
            clientId: localStorage.getItem('onesignal_userId'),
            bundleId: 'camera.beex.vn',
            type: 3,
            namespace: activeNamespace,
          }),
        }),
      );
      dispatch(updateNamespace(activeNamespace));
    }
  }, [dispatch, isAuth, listNamespace]);

  useEffect(() => {
    if (isAuth === 1) {
      return dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.LIST_NAMESPACE_BY_ACCOUNT,
          requestId: new Date().getTime(),
          body: JSON.stringify({}),
        }),
      );
    }
    return () => {};
  }, [dispatch, isAuth]);

  useEffect(() => {
    if (isAuth === 1 && namespace) setIsLogin(true);
  }, [isAuth, namespace]);

  useEffect(() => {
    if (language) {
      moment.locale(language);
      i18n.changeLanguage(language);
      localStorage.setItem(SYSTEM.LANGUAGE, language);
    }
  }, [i18n, language]);

  useEffect(() => {
    document.title = TITLE_APP[HOST_NAME] || 'BeeX';
    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon && ICON_APP[HOST_NAME]) favicon.href = ICON_APP[HOST_NAME];
  }, []);

  useEffect(() => {
    beeXLogger.debug('MOUNT APP: ', {
      current,
      mainTabKey,
      allowMultiTab,
      isLogin,
    });
  }, [current, mainTabKey, allowMultiTab, isLogin]);

  return isInitialSetup ? (
    <Router>
      <AppInner
        isLogin={isLogin}
        current={current}
        mainTabKey={mainTabKey}
        allowMultiTab={allowMultiTab}
        onMainTabChange={onMainTabChange}
      />
    </Router>
  ) : (
    <Spinner />
  );
}
